"use strict";

var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decideModel = exports.measureAndDecideExecutionApproach = void 0;
var loader_js_1 = require("./loader.js");
var support_js_1 = require("./support.js");
var DEFAULT_EXECUTION_QUANTA = 3;
var SIMD_SCORE_FIXED_POINT = 2.50;
var WASM_SCORE_FIXED_POINT = 2.63;
var SINGLE_INLINE_SCORE_MULTIPLIER = 0.6;
var QUALITY_MULTIPLE_QUANTA_SCORE_MULTIPLIER = 0.65;
var INTERACTIVITY_MULTIPLE_QUANTA_SCORE_MULTIPLIER = 0.5;
var WORKER_SCORE_MULTIPLIER = 0.7;
var PERFORMANCE_THRESHOLDS = {
  wasm: {
    noSupport: 0.07,
    inline: {
      c100: 1,
      c50: 0.36,
      c20: 0.16,
      c10: 0.07
    },
    worker: {
      c100: 0.5,
      c50: 0.18,
      c20: 0.08,
      c10: 0.06
    }
  },
  simd: {
    noSupport: 0.10,
    inline: {
      c100: 1,
      c50: 0.43,
      c20: 0.3,
      c10: 0.2
    },
    worker: {
      c100: 0.5,
      c50: 0.21,
      c20: 0.15,
      c10: 0.10
    }
  }
};
var Estimator = /*#__PURE__*/function () {
  function Estimator(fetchConfig, logger) {
    _classCallCheck(this, Estimator);
    this.fetchConfig = fetchConfig;
    this.logger = logger;
    var workerURL = "".concat(fetchConfig.paths.workers, "estimator-v1.js");
    this.fetchBehavior = {
      headers: fetchConfig.headers,
      escapedQueryString: fetchConfig.escapedQueryString
    };
    this.worker = loader_js_1.loadWorker(workerURL, 'VoiceFocusEstimator', this.fetchBehavior, logger);
  }
  _createClass(Estimator, [{
    key: "roundtrip",
    value: function roundtrip(toSend, receive, expectedKey) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        _this.worker.then(function (worker) {
          var _listener;
          _listener = function listener(event) {
            var _event$data = event.data,
              message = _event$data.message,
              key = _event$data.key;
            if (message === receive && key === expectedKey) {
              worker.removeEventListener('message', _listener);
              resolve(event.data);
            }
          };
          worker.addEventListener('message', _listener);
          worker.postMessage(toSend);
        }).catch(function (e) {
          var _a;
          (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.error('Failed to load worker.', e);
          reject(e);
        });
      });
    }
  }, {
    key: "supportsSIMD",
    value: function supportsSIMD(url) {
      var key = 'simd';
      var path = url || "".concat(this.fetchConfig.paths.wasm, "simd-v1.wasm");
      var toSend = {
        message: 'supports-simd',
        fetchBehavior: this.fetchBehavior,
        path: path,
        key: key
      };
      return this.roundtrip(toSend, 'simd-support', key).then(function (data) {
        return data.supports;
      });
    }
  }, {
    key: "measure",
    value: function measure(simd, budget) {
      var benchWASM = "".concat(this.fetchConfig.paths.wasm, "bench-v1.wasm");
      var benchSIMD = "".concat(this.fetchConfig.paths.wasm, "bench-v1_simd.wasm");
      var path = simd ? benchSIMD : benchWASM;
      var key = "bench:".concat(simd);
      var toSend = {
        message: 'measure',
        fetchBehavior: this.fetchBehavior,
        budget: budget,
        path: path,
        key: key
      };
      return this.roundtrip(toSend, 'measurement', key).then(function (data) {
        if (data.measurement) {
          return data.measurement;
        }
        throw new Error('Failed to measure.');
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this2 = this;
      this.worker.then(function (worker) {
        var _a;
        (_a = _this2.logger) === null || _a === void 0 ? void 0 : _a.debug('Stopping estimator worker.');
        worker.terminate();
      }).catch(function (e) {});
    }
  }]);
  return Estimator;
}();
var inlineScoreMultiplier = function inlineScoreMultiplier(executionQuanta, usagePreference) {
  if (executionQuanta === 1) {
    return SINGLE_INLINE_SCORE_MULTIPLIER;
  }
  if (usagePreference === 'quality') {
    return QUALITY_MULTIPLE_QUANTA_SCORE_MULTIPLIER * executionQuanta;
  }
  return INTERACTIVITY_MULTIPLE_QUANTA_SCORE_MULTIPLIER * executionQuanta;
};
var decideExecutionApproach = function decideExecutionApproach(_ref) {
  var supportsSIMD = _ref.supportsSIMD,
    supportsSAB = _ref.supportsSAB,
    duration = _ref.duration,
    _ref$executionPrefere = _ref.executionPreference,
    executionPreference = _ref$executionPrefere === void 0 ? 'auto' : _ref$executionPrefere,
    simdPreference = _ref.simdPreference,
    _ref$variantPreferenc = _ref.variantPreference,
    variantPreference = _ref$variantPreferenc === void 0 ? 'auto' : _ref$variantPreferenc,
    _ref$namePreference = _ref.namePreference,
    namePreference = _ref$namePreference === void 0 ? 'default' : _ref$namePreference,
    usagePreference = _ref.usagePreference,
    _ref$executionQuantaP = _ref.executionQuantaPreference,
    executionQuantaPreference = _ref$executionQuantaP === void 0 ? DEFAULT_EXECUTION_QUANTA : _ref$executionQuantaP;
  var allThresholds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PERFORMANCE_THRESHOLDS;
  var logger = arguments.length > 2 ? arguments[2] : undefined;
  var forceSIMD = simdPreference === 'force';
  var useSIMD = forceSIMD || simdPreference !== 'disable' && supportsSIMD;
  var checkScores = duration !== -1;
  var baseScore = checkScores ? (useSIMD ? SIMD_SCORE_FIXED_POINT : WASM_SCORE_FIXED_POINT) / duration : 0;
  var thresholds = useSIMD ? allThresholds.simd : allThresholds.wasm;
  var inlineScore = checkScores ? inlineScoreMultiplier(executionQuantaPreference, usagePreference) * baseScore : 0;
  var workerScore = checkScores ? WORKER_SCORE_MULTIPLIER * baseScore : 0;
  var name = namePreference;
  var unsupported = function unsupported(reason) {
    return {
      supported: false,
      reason: reason
    };
  };
  if (checkScores) {
    if (baseScore < thresholds.noSupport) {
      return unsupported("Performance score ".concat(baseScore, " worse than threshold ").concat(thresholds.noSupport, "."));
    }
  } else {
    if (executionPreference === 'auto' || variantPreference === 'auto') {
      return unsupported("Missing explicit execution (".concat(executionPreference, ") or variant (").concat(variantPreference, ") preference, but no scoring performed."));
    }
  }
  logger === null || logger === void 0 ? void 0 : logger.debug("Bench duration ".concat(duration, " yields inline score ").concat(inlineScore, " and worker score ").concat(workerScore, "."));
  var succeed = function succeed(processor, executionApproach, variant) {
    return {
      supported: true,
      useSIMD: useSIMD,
      processor: processor,
      executionApproach: executionApproach,
      variant: variant,
      executionQuanta: executionApproach === 'inline' ? executionQuantaPreference : undefined,
      name: name
    };
  };
  var resolveVariant = function resolveVariant(score, variant, lookup) {
    if (variant !== 'auto') {
      if (!checkScores || score > lookup[variant]) {
        return variant;
      }
      return 'failed';
    }
    if (score > lookup.c100) {
      return 'c100';
    }
    if (score > lookup.c50) {
      return 'c50';
    }
    if (score > lookup.c20) {
      return 'c20';
    }
    if (score > lookup.c10) {
      return 'c10';
    }
    return 'failed';
  };
  var _reducePreference = function reducePreference(preference) {
    switch (preference || 'auto') {
      case 'auto':
        {
          var inlineOption = _reducePreference('inline');
          var workerOption = _reducePreference('worker');
          logger === null || logger === void 0 ? void 0 : logger.debug("Reducing auto preference: ".concat(JSON.stringify(inlineOption), " vs ").concat(JSON.stringify(workerOption)));
          if (inlineOption.supported === false) {
            return workerOption;
          }
          if (workerOption.supported === false) {
            return workerOption;
          }
          if (inlineOption.variant === workerOption.variant || inlineOption.variant === 'c50') {
            return inlineOption;
          }
          return workerOption;
        }
      case 'worker':
        {
          if (support_js_1.supportsSharedArrayBuffer(globalThis, window, logger)) {
            return _reducePreference('worker-sab');
          }
          return _reducePreference('worker-postMessage');
        }
      case 'inline':
        {
          var variant = resolveVariant(inlineScore, variantPreference, thresholds.inline);
          if (variant === 'failed') {
            return unsupported("Performance score ".concat(inlineScore, " not sufficient for inline use with variant preference ").concat(variantPreference, "."));
          }
          ;
          return succeed('voicefocus-inline-processor', 'inline', variant);
        }
      case 'worker-sab':
        {
          if (!supportsSAB) {
            var reason = 'Requested worker-sab but no SharedArrayBuffer support.';
            logger === null || logger === void 0 ? void 0 : logger.warn(reason);
            return {
              supported: false,
              reason: reason
            };
          }
          var _variant = resolveVariant(workerScore, variantPreference, thresholds.worker);
          if (_variant === 'failed') {
            return unsupported("Performance score ".concat(workerScore, " not sufficient for worker use with variant preference ").concat(variantPreference, "."));
          }
          ;
          return succeed('voicefocus-worker-sab-processor', 'worker-sab', _variant);
        }
      case 'worker-postMessage':
        {
          var _variant2 = resolveVariant(workerScore, variantPreference, thresholds.worker);
          if (_variant2 === 'failed') {
            return unsupported("Performance score ".concat(workerScore, " not sufficient for worker use."));
          }
          ;
          if (name === 'ns_es') {
            var _reason = 'Requested echo suppression but postMessage executor does not support it.';
            logger === null || logger === void 0 ? void 0 : logger.warn(_reason);
            return {
              supported: false,
              reason: _reason
            };
          }
          ;
          return succeed('voicefocus-worker-postMessage-processor', 'worker-postMessage', _variant2);
        }
    }
  };
  return _reducePreference(executionPreference);
};
var featureCheck = function featureCheck(forceSIMD, fetchConfig, logger, estimator) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var supports, cleanup, e, useSIMD;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          supports = {
            supportsSIMD: forceSIMD,
            supportsSAB: support_js_1.supportsSharedArrayBuffer(globalThis, window, logger),
            duration: -1
          };
          if (!forceSIMD) {
            _context.next = 4;
            break;
          }
          logger === null || logger === void 0 ? void 0 : logger.info('Supports SIMD: true (force)');
          return _context.abrupt("return", supports);
        case 4:
          cleanup = !estimator;
          e = estimator || new Estimator(fetchConfig, logger);
          _context.prev = 6;
          _context.t0 = !support_js_1.isOldChrome(window, logger);
          if (!_context.t0) {
            _context.next = 12;
            break;
          }
          _context.next = 11;
          return e.supportsSIMD();
        case 11:
          _context.t0 = _context.sent;
        case 12:
          useSIMD = _context.t0;
          logger === null || logger === void 0 ? void 0 : logger.info("Supports SIMD: ".concat(useSIMD, " (force: ").concat(forceSIMD, ")"));
          supports.supportsSIMD = useSIMD;
          return _context.abrupt("return", supports);
        case 16:
          _context.prev = 16;
          if (cleanup) {
            e.stop();
          }
          return _context.finish(16);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6,, 16, 19]]);
  }));
};
var estimateAndFeatureCheck = function estimateAndFeatureCheck(forceSIMD, fetchConfig, estimatorBudget, logger) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var estimator, supports;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          estimator = new Estimator(fetchConfig, logger);
          _context2.prev = 1;
          _context2.next = 4;
          return featureCheck(forceSIMD, fetchConfig, logger, estimator);
        case 4:
          supports = _context2.sent;
          if (!supports.supportsSIMD) {
            _context2.next = 18;
            break;
          }
          _context2.prev = 6;
          _context2.next = 9;
          return estimator.measure(true, estimatorBudget);
        case 9:
          supports.duration = _context2.sent;
          logger === null || logger === void 0 ? void 0 : logger.info('SIMD timing:', supports.duration);
          return _context2.abrupt("return", supports);
        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2["catch"](6);
          logger === null || logger === void 0 ? void 0 : logger.warn('Failed SIMD estimation; falling back to non-SIMD.');
          supports.supportsSIMD = false;
        case 18:
          _context2.next = 20;
          return estimator.measure(false, estimatorBudget);
        case 20:
          supports.duration = _context2.sent;
          logger === null || logger === void 0 ? void 0 : logger.info('No-SIMD timing:', supports.duration);
          return _context2.abrupt("return", supports);
        case 25:
          _context2.prev = 25;
          _context2.t1 = _context2["catch"](1);
          logger === null || logger === void 0 ? void 0 : logger.error('Could not feature check.', _context2.t1);
          throw _context2.t1;
        case 29:
          _context2.prev = 29;
          estimator.stop();
          return _context2.finish(29);
        case 32:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 25, 29, 32], [6, 14]]);
  }));
};
var measureAndDecideExecutionApproach = function measureAndDecideExecutionApproach(spec, fetchConfig, logger) {
  var thresholds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : PERFORMANCE_THRESHOLDS;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var executionPreference, usagePreference, variantPreference, namePreference, simdPreference, estimatorBudget, executionQuantaPreference, forceSIMD, knownModel, knownExecution, supports;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          executionPreference = spec.executionPreference;
          usagePreference = spec.usagePreference, variantPreference = spec.variantPreference, namePreference = spec.namePreference, simdPreference = spec.simdPreference, estimatorBudget = spec.estimatorBudget, executionQuantaPreference = spec.executionQuantaPreference;
          if (usagePreference === 'interactivity' && executionPreference !== 'inline') {
            logger === null || logger === void 0 ? void 0 : logger.debug("Overriding execution preference ".concat(executionPreference, " to reflect interactivity preference."));
            executionPreference = 'inline';
          }
          forceSIMD = simdPreference === 'force';
          knownModel = variantPreference !== 'auto';
          knownExecution = executionPreference !== 'auto';
          _context3.prev = 6;
          if (!(knownModel && knownExecution)) {
            _context3.next = 13;
            break;
          }
          _context3.next = 10;
          return featureCheck(forceSIMD, fetchConfig, logger);
        case 10:
          supports = _context3.sent;
          _context3.next = 16;
          break;
        case 13:
          _context3.next = 15;
          return estimateAndFeatureCheck(forceSIMD, fetchConfig, estimatorBudget, logger);
        case 15:
          supports = _context3.sent;
        case 16:
          _context3.next = 22;
          break;
        case 18:
          _context3.prev = 18;
          _context3.t0 = _context3["catch"](6);
          logger === null || logger === void 0 ? void 0 : logger.error('Could not load estimator.', _context3.t0);
          throw new Error('Could not load Voice Focus estimator.');
        case 22:
          return _context3.abrupt("return", decideExecutionApproach(Object.assign(Object.assign({}, supports), {
            simdPreference: simdPreference,
            executionPreference: executionPreference,
            variantPreference: variantPreference,
            namePreference: namePreference,
            usagePreference: usagePreference,
            executionQuantaPreference: executionQuantaPreference
          }), thresholds, logger));
        case 23:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[6, 18]]);
  }));
};
exports.measureAndDecideExecutionApproach = measureAndDecideExecutionApproach;
var decideModel = function decideModel(_ref2) {
  var category = _ref2.category,
    name = _ref2.name,
    variant = _ref2.variant,
    simd = _ref2.simd,
    url = _ref2.url;
  return "".concat(category, "-").concat(name, "-").concat(variant, "-v1").concat(simd ? '_simd' : '');
};
exports.decideModel = decideModel;